import React from 'react';
import Lottie from 'react-lottie';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import phonicsBackground from '@/assets/productCenter/ai/ai-bg.jpg';
import starData from '@/assets/lottie/star-data.json';

const starLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: starData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      <div
        className={styles['screen1-bg']}
        style={{ backgroundImage: `url(${phonicsBackground})` }}
        aria-hidden
      />
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-title']}`}
            style={{ animationDelay: '0.2s', animationDuration: '1.2s' }}
          >
            <div className={styles['screen1-title-row']}>
              爱学AI一对一导师
              <span className={styles['screen1-star-wrap']} aria-hidden>
                <Lottie options={starLottieOptions} />
              </span>
            </div>
          </div>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-desc']}`}
            style={{ animationDelay: '0.4s', animationDuration: '1.2s' }}
          >
            爱学AI一对一导师是新一代AI互动学习产品。它依托于自研的爱学大模型，利用真人级数字人导师，结合多模态感知能力，构建全年龄、全学科、全方位的智能学习场景，为学习者提供终身学习的个性化成长陪伴。
          </div>
        </div>
      </div>
    </section>
  );
}
